"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductManufacturer = void 0;
const common_1 = require("../../common");
class ProductManufacturer extends common_1.MongoDocument {
}
exports.ProductManufacturer = ProductManufacturer;
//# sourceMappingURL=product-manufacturer.model.js.map